export default "__VITE_ASSET__DX9_EA6z__"